const alldealsolddata = { data: [], loading: true };

export const GetAllDealSoldRed = (state = alldealsolddata, action) => {
  switch (action.type) {
    case "get_dealsolddata":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
